<template>
    <inter-table
            :showFilters="true"
            :fields="fields"
            :filters="filters"
            action="contacts"
    >

        <template v-slot:cell(name)="data">
            <div class="text-uppercase">
                {{data.item.surname}} {{data.item.name}}
            </div>
            <div class="text-uppercase text-primary small">
                {{data.item.user && data.item.user.data ? data.item.user.data.society : ''}}
            </div>
        </template>

        <template v-slot:cell(birth_date)="data">
            {{data.item.birth_date | date}}
        </template>

        <template v-slot:cell(age)="data">
            {{getAge(data.item.birth_date)}}
        </template>

        <template v-slot:cell(birth_place)="data">
            <div class="text-uppercase text-truncate">
                {{data.item.comune_nascita ? data.item.comune_nascita.comune : 'N.D.'}}
            </div>
        </template>


        <template slot="custom-filters">
            <b-col cols="12" md="6" class="mb-3">
                <inter-select
                        asyncFindAction="select/societies"
                        placeholder="Società"
                        v-model="filters.society"
                ></inter-select>
            </b-col>
            <div class="w-100"></div>
        </template>

    </inter-table>
</template>

<script>
    import InterTable from "../../../components/table/InterTable";
    import InterSelect from "../../../components/form/inter-select/InterSelect";
    import Moment from 'moment';

    export default {
        name: "AdminContactsTable",
        components: {InterSelect, InterTable},
        data() {
            return {
                filters: {},
                fields: [
                    {key: 'name', label: 'Nome', class: 'text-left'},
                    {key: 'email', label: 'Email', class: 'text-left'},
                    {key: 'birth_place', label: 'Nato a', class: 'text-left'},
                    {key: 'birth_date', label: 'Nato il', class: 'text-center'},
                    {key: 'age', label: 'Età', class: 'text-center'},
                ],
            }
        },
        computed: {

        },
        mounted() {

        },
        methods: {

            getAge: function (date) {
                return Moment().diff(date, 'years');
            }
        }
    }
</script>

<style scoped>

</style>
